import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Hiredeveloperslider() {
  return (
    <div className="hire_developer_slider hire_net_slider p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>Top-Picked Android App Developers for Hire</h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <Swiper
              loop={true}
              spaceBetween={25}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              // autoplay={false}
              modules={[Autoplay]}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                1024: {
                  slidesPerView: 3,
                },
                1366: {
                  slidesPerView: 3,
                },
                1400: {
                  slidesPerView: 4,
                },
                1600: {
                  slidesPerView: 4,
                },
              }}
              className=""
            >
              <SwiperSlide>
                <div className="best_app_main">
                  <div className="best_app_box">
                    <div className="best_app_img">
                      <StaticImage
                        src="../../images/services-usa/dot_net/ifran_qamar.webp"
                        alt="TekRevol"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={123}
                        height={122}
                      />
                    </div>
                    <div className="best_app_head">
                      <h6>Irfan Qamar</h6>
                      <span>Game Developer</span>
                      <p>
                        Irfan is a game developer with over ten years of
                        experience. During this time, he developed more than 12
                        games.
                      </p>
                    </div>
                  </div>
                  <div className="best_app_content_main">
                    <div className="best_info">
                      <h6>
                        Years Of
                        <br /> Experience
                      </h6>
                      <h6>Availability</h6>
                    </div>
                    <div className="best_info_num">
                      <p>07+</p>
                      <p>Full-Time</p>
                    </div>
                  </div>
                  <div className="expert_main">
                    <div className="expert_head">
                      <h6>Expert in</h6>
                    </div>
                    <div className="expert_info">
                      <ul>
                        <li>C#</li>
                        <li>Javascript</li>
                      </ul>
                    </div>
                  </div>
                  <div className="best_app_btn">
                    <Link to="/contact" className="" aria-label="TekRevol hire">
                      Hire Game Developer
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="best_app_main">
                  <div className="best_app_box">
                    <div className="best_app_img">
                      <StaticImage
                        src="../../images/services-usa/dot_net/hiba.webp"
                        alt="hire_app"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={124}
                        height={122}
                      />
                    </div>
                    <div className="best_app_head">
                      <h6>Hiba Pervez</h6>
                      <span>Android Developer</span>
                      <p>
                        Hiba is a android developer with over ten years of
                        experience. During this time, she developed more than 15
                        android application.
                      </p>
                    </div>
                  </div>
                  <div className="best_app_content_main">
                    <div className="best_info">
                      <h6>
                        Years Of
                        <br /> Experience
                      </h6>
                      <h6>Availability</h6>
                    </div>
                    <div className="best_info_num">
                      <p>10+</p>
                      <p>Full-Time</p>
                    </div>
                  </div>
                  <div className="expert_main">
                    <div className="expert_head">
                      <h6>Expert in</h6>
                    </div>
                    <div className="expert_info">
                      <ul>
                        <li>Java</li>
                        <li>Kotlin</li>
                      </ul>
                    </div>
                  </div>
                  <div className="best_app_btn">
                    <Link to="/contact" className="" aria-label="TekRevol hire">
                      Hire Android Developer
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="best_app_main">
                  <div className="best_app_box">
                    <div className="best_app_img">
                      <StaticImage
                        src="../../images/services-usa/dot_net/ejaz_amir.webp"
                        alt="hire_app"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={123}
                        height={122}
                      />
                    </div>
                    <div className="best_app_head">
                      <h6>Ijaz Aamir</h6>
                      <span>Flutter Developer</span>
                      <p>
                        Ijaz is a Flutter developer with over ten years of
                        experience. During this time, he developed more than 18
                        Flutter application.
                      </p>
                    </div>
                  </div>
                  <div className="best_app_content_main">
                    <div className="best_info">
                      <h6>
                        Years Of
                        <br /> Experience
                      </h6>
                      <h6>Availability</h6>
                    </div>
                    <div className="best_info_num">
                      <p>12+</p>
                      <p>Full-Time</p>
                    </div>
                  </div>
                  <div className="expert_main">
                    <div className="expert_head">
                      <h6>Expert in</h6>
                    </div>
                    <div className="expert_info">
                      <ul>
                        <li>Flutter</li>
                        <li>Dart</li>
                      </ul>
                    </div>
                  </div>
                  <div className="best_app_btn">
                    <Link to="/contact" className="" aria-label="TekRevol hire">
                      Hire Flutter Developer
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="best_app_main">
                  <div className="best_app_box">
                    <div className="best_app_img">
                      <StaticImage
                        src="../../images/services-usa/dot_net/waiz_ali.webp"
                        alt="hire_app"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={124}
                        height={122}
                      />
                    </div>
                    <div className="best_app_head">
                      <h6>Waiz Ali</h6>
                      <span>iOS Developer</span>
                      <p>
                        Waiz is a iOS developer with over ten years of
                        experience. During this time, he developed more than 15
                        iOS application.
                      </p>
                    </div>
                  </div>
                  <div className="best_app_content_main">
                    <div className="best_info">
                      <h6>
                        Years Of
                        <br /> Experience
                      </h6>
                      <h6>Availability</h6>
                    </div>
                    <div className="best_info_num">
                      <p>10+</p>
                      <p>Full-Time</p>
                    </div>
                  </div>
                  <div className="expert_main">
                    <div className="expert_head">
                      <h6>Expert in</h6>
                    </div>
                    <div className="expert_info">
                      <ul>
                        <li>Swift</li>
                        <li>Objective-C</li>
                      </ul>
                    </div>
                  </div>
                  <div className="best_app_btn">
                    <Link to="/contact" className="" aria-label="TekRevol hire">
                      Hire iOS Developer
                    </Link>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="best_app_main">
                  <div className="best_app_box">
                    <div className="best_app_img">
                      <StaticImage
                        src="../../images/services-usa/dot_net/ifran_qamar.webp"
                        alt="TekRevol"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={123}
                        height={122}
                      />
                    </div>
                    <div className="best_app_head">
                      <h6>Irfan Qamar</h6>
                      <span>Game Developer</span>
                      <p>
                        Irfan is a game developer with over ten years of
                        experience. During this time, he developed more than 12
                        games.
                      </p>
                    </div>
                  </div>
                  <div className="best_app_content_main">
                    <div className="best_info">
                      <h6>
                        Years Of
                        <br /> Experience
                      </h6>
                      <h6>Availability</h6>
                    </div>
                    <div className="best_info_num">
                      <p>07+</p>
                      <p>Full-Time</p>
                    </div>
                  </div>
                  <div className="expert_main">
                    <div className="expert_head">
                      <h6>Expert in</h6>
                    </div>
                    <div className="expert_info">
                      <ul>
                        <li>C#</li>
                        <li>Javascript</li>
                      </ul>
                    </div>
                  </div>
                  <div className="best_app_btn">
                    <Link to="/contact" className="" aria-label="TekRevol hire">
                      Hire Game Developer
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="best_app_main">
                  <div className="best_app_box">
                    <div className="best_app_img">
                      <StaticImage
                        src="../../images/services-usa/dot_net/hiba.webp"
                        alt="hire_app"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={124}
                        height={122}
                      />
                    </div>
                    <div className="best_app_head">
                      <h6>Hiba Pervez</h6>
                      <span>Android Developer</span>
                      <p>
                        Hiba is a android developer with over ten years of
                        experience. During this time, she developed more than 15
                        android application.
                      </p>
                    </div>
                  </div>
                  <div className="best_app_content_main">
                    <div className="best_info">
                      <h6>
                        Years Of
                        <br /> Experience
                      </h6>
                      <h6>Availability</h6>
                    </div>
                    <div className="best_info_num">
                      <p>10+</p>
                      <p>Full-Time</p>
                    </div>
                  </div>
                  <div className="expert_main">
                    <div className="expert_head">
                      <h6>Expert in</h6>
                    </div>
                    <div className="expert_info">
                      <ul>
                        <li>Java</li>
                        <li>Kotlin</li>
                      </ul>
                    </div>
                  </div>
                  <div className="best_app_btn">
                    <Link to="/contact" className="" aria-label="TekRevol hire">
                      Hire Android Developer
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="best_app_main">
                  <div className="best_app_box">
                    <div className="best_app_img">
                      <StaticImage
                        src="../../images/services-usa/dot_net/ejaz_amir.webp"
                        alt="hire_app"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={123}
                        height={122}
                      />
                    </div>
                    <div className="best_app_head">
                      <h6>Ijaz Aamir</h6>
                      <span>Flutter Developer</span>
                      <p>
                        Ijaz is a Flutter developer with over ten years of
                        experience. During this time, he developed more than 18
                        Flutter application.
                      </p>
                    </div>
                  </div>
                  <div className="best_app_content_main">
                    <div className="best_info">
                      <h6>
                        Years Of
                        <br /> Experience
                      </h6>
                      <h6>Availability</h6>
                    </div>
                    <div className="best_info_num">
                      <p>12+</p>
                      <p>Full-Time</p>
                    </div>
                  </div>
                  <div className="expert_main">
                    <div className="expert_head">
                      <h6>Expert in</h6>
                    </div>
                    <div className="expert_info">
                      <ul>
                        <li>Flutter</li>
                        <li>Dart</li>
                      </ul>
                    </div>
                  </div>
                  <div className="best_app_btn">
                    <Link to="/contact" className="" aria-label="TekRevol hire">
                      Hire Flutter Developer
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="best_app_main">
                  <div className="best_app_box">
                    <div className="best_app_img">
                      <StaticImage
                        src="../../images/services-usa/dot_net/waiz_ali.webp"
                        alt="hire_app"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={124}
                        height={122}
                      />
                    </div>
                    <div className="best_app_head">
                      <h6>Waiz Ali</h6>
                      <span>iOS Developer</span>
                      <p>
                        Waiz is a iOS developer with over ten years of
                        experience. During this time, he developed more than 15
                        iOS application.
                      </p>
                    </div>
                  </div>
                  <div className="best_app_content_main">
                    <div className="best_info">
                      <h6>
                        Years Of
                        <br /> Experience
                      </h6>
                      <h6>Availability</h6>
                    </div>
                    <div className="best_info_num">
                      <p>10+</p>
                      <p>Full-Time</p>
                    </div>
                  </div>
                  <div className="expert_main">
                    <div className="expert_head">
                      <h6>Expert in</h6>
                    </div>
                    <div className="expert_info">
                      <ul>
                        <li>Swift</li>
                        <li>Objective-C</li>
                      </ul>
                    </div>
                  </div>
                  <div className="best_app_btn">
                    <Link to="/contact" className="" aria-label="TekRevol hire">
                      Hire iOS Developer
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Hiredeveloperslider;
